import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class BackOfficeTrialBankruptcyTransformer  {
    _originalTypeClassName = "zERP.BO.BackOfficeTrialBankruptcyTransformer";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
BackOfficeTrialBankruptcyTransformer.translate = translateService;
}
this.BackOfficeTrialBankruptcyTransformerKey = null;
this._key = this.BackOfficeTrialBankruptcyTransformerKey = 0; 
}

static translate: TranslateService;
_key: any;
private _BackOfficeTrialBankruptcyTransformerKey:any;
get BackOfficeTrialBankruptcyTransformerKey(): any {
    return this._BackOfficeTrialBankruptcyTransformerKey;
  }
set BackOfficeTrialBankruptcyTransformerKey(value: any) {
    this._BackOfficeTrialBankruptcyTransformerKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.BackOfficeTrialBankruptcyTransformerKey == null || $this.BackOfficeTrialBankruptcyTransformerKey == 0;
            }


}